import React from "react";
import "../../styles/showCase.css";
import { Box } from "@mui/system";
import { Button, Grid, Typography } from "@mui/material";
import { mainHeading, showCaseBtn, subHeading } from "../../styles/style";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ShowCaseCard from "../../assets/cards/ShowCaseCard";

export default function ShowcaseTalent() {
  return (
    <>
      <section id="showCase">
        <Box className="pplacd-container">
          <Box
            sx={{
              display: "flex",
              flexDirection:{xs:'column',  md:'row'},
              justifyContent: "space-between",
              alignItems: {xs:'start',  md:'end'},
            }}
          >
            <Box>
              <Typography sx={subHeading}>Top Jobs</Typography>
              <Typography sx={mainHeading}>
                Showcase your talent & grab the opportunity
              </Typography>
            </Box>

            <Button
              variant="contained"
              sx={showCaseBtn}
              endIcon={<KeyboardArrowRightIcon />}
            >
              Browse All Jobs
            </Button>
          </Box>

          <Grid container spacing={2} mt={5}>
            <Grid item md={4} mb={4}>
                <ShowCaseCard/>
            </Grid>
            <Grid item md={4} mb={4}>
                <ShowCaseCard/>
            </Grid>
            <Grid item md={4} mb={4}>
                <ShowCaseCard/>
            </Grid>
            <Grid item md={4} mb={4}>
                <ShowCaseCard/>
            </Grid>
            <Grid item md={4} mb={4}>
                <ShowCaseCard/>
            </Grid>
            <Grid item md={4} mb={4}>
                <ShowCaseCard/>
            </Grid>
          </Grid>
        </Box>
      </section>
    </>
  );
}
